<template>
  <v-main>
    <v-fade-transition mode="out-in">
      <router-view 
        :active="active"
        :scroll="scroll"
        :height="height"
        :installed="installed"
        :modal="modal"
        :dev="dev"
        :ready="ready"
      />
    </v-fade-transition>
  </v-main>
</template>

<script>
  export default {
    name: 'PageView',

    props: {
      scroll: {
        type: Number,
        default: 0
      },
      height: {
        type: Number,
        default: 0
      },
      active: {
        type: Boolean,
        default: true
      },
      installed: {
        type: Boolean,
        default: false
      },
      modal: {
        type: String,
        default: null
      },
      dev: {
        type: Boolean,
        default: false
      },
      ready: {
        type: Boolean,
        default: false
      }
    },
  }
</script>
